

import {configureStore, createSlice , createAction  }  from "@reduxjs/toolkit";



const calendarSlice = createSlice({
  name : "calendar" ,
  initialState : {eventtochange:{},listcalendarevents:[]},
  reducers :{seteventtochange: (state, action)=>{ return  {...state,eventtochange :action.payload} },
              allcalendarevents : (state, action)=>{return  {...state,listcalendarevents: action.payload} }, }
});

const leadSlice = createSlice({
    name : "lead" ,
    initialState :{  leadactu:{},leadmemo:{} , memoconjoint:{} ,memoenfants:{},  leadappelant :{}, qualiflead : true },
    reducers :{   initialiseLeadactu : (state, action)=>{ return  {...state,leadactu :action.payload} },

                  modifyChampsLeadactu : (state, action)=>{  return  {...state,leadactu :{...state.leadactu,...action.payload}} },

                  deleteChampsLeadactu : (state, action)=>{const copylead = {...state.leadactu};  action.payload.map(x =>  delete copylead[x]) ;
                                                         return {...state, leadactu : copylead}  },
                  
                  initialiseLeadappelant : (state, action)=>{  return  {...state,leadappelant :action.payload} },
                 
                  initialiseLeadmemo : (state, action)=>{ const leed =   {...action.payload};
                                  return  {...state,leadmemo :leed} },
                  
                  modifyChampsLeadmemo : (state, action)=>{  return  {...state,leadmemo :{...state.leadmemo,...action.payload}} },

                  deleteChampsLeadmemo : (state, action)=>{
                    const copylead = {...state.leadmemo}; action.payload.map(x => delete copylead[x]) ;
                    return {...state, leadmemo : copylead} }, 

                  initialiseLeadmemoConjoint : (state, action)=>{ const conjoint =   {...action.payload};
                                  Object.keys(conjoint).map(key=>(conjoint[key]==="" ||conjoint[key]===null )&& delete conjoint[key]   )     ;
                                return  {...state,memoconjoint :conjoint} },
                  
                  initialiseLeadMemoEnfants : (state, action)=>{ return  {...state,memoenfants :action.payload} },

                  modifyQualiflead: (state, action)=>{  return  {...state,qualiflead :action.payload} },
    }
});

export const leadsSlice = createSlice({
    name: "leads",
    initialState: {initiaload:true ,leads: []  ,  fileattentes:[] , campagnes:[] , leadsfiltres :null ,choiceliste:"newleads" ,
                   filtrescom :{'status':null, 'interaction' :null ,'campagne':null , 'hot':0 ,'date1':(new Date((new Date()).setMonth((new Date()).getMonth()-6))).setHours(0,0,0),'date2':(new Date()).setHours(0,0,0)} ,
                   filtresmanager :{'selectonecom' : 'all'  ,'selectstatut': 'all' ,'date1':(new Date((new Date()).setDate(1))).setHours(0,0,0) ,'date2':(new Date()).setHours(23,59,0) , 'commerciauxffiches':[]}} ,
    reducers: { setInitiaload: (state, action) => { state.initiaload=action.payload   ; },
                allLeads: (state, action) => { state.leads=action.payload   ; },
                defineCampagnes: (state, action) => { state.campagnes=action.payload   ; },
                addlead: (state, action) => {  state.leads=[...state.leads,action.payload] } ,
                deletelead :(state,action)=>{state.leads = state.leads.filter(x=>x.id!==action.payload)},
                setFileattentes : (state, action) => { state.fileattentes=action.payload   ; },
                setLeadsfiltres: (state, action) => { state.leadsfiltres=action.payload   ; },
                setFiltrescom: (state, action) => { state.filtrescom=action.payload   ; },
                setFiltresmanager: (state, action) => { state.filtresmanager=action.payload   ; },
                setChoiceliste: (state, action) => { state.choiceliste=action.payload   ; },
              }
});


  export const formulesSlice = createSlice({
    name: "formules",
    initialState: {corell:'',datas:[],loadingformules:false,allformulesshow:false,formuleshow:null,favorisshow:false, 
                    devisformules:[], listecompagnies:[], listecompagniesaffichees:[] , idsNeeds:[] , compagniewait: null ,
                   listcontrollers :[]},
    reducers: { setCorell: (state, action) => {state.corell = action.payload;},
                allFormules: (state, action) => {state.datas = action.payload;},
                defineLoadingformules: (state, action) => {state.loadingformules = action.payload;},
                defineFormuleShow: (state, action) => {state.formuleshow = action.payload;},
                defineFavorisShow: (state, action) => {state.favorisshow = action.payload;},
                defineAllFormulesShow: (state, action) => {state.allformulesshow = action.payload;},
                defineIdsNeeds: (state, action) => {state.idsNeeds = action.payload;},
                defineListeCompagnies: (state, action) => {state.listecompagnies = [...new Set(action.payload)];},
                defineListeCompagniesAffichees: (state, action) => {state.listecompagniesaffichees = action.payload;},
                defineDevisFormules: (state, action) => { state.devisformules = action.payload;},
                defineCompagnieWait: (state, action) => {state.compagniewait = action.payload;},
                defineListControllers: (state, action) => {state.listcontrollers = action.payload;},
                
    }
  });

  
  const displaySlice = createSlice({
    name : "display" ,
    initialState : {screenvalidcontrat : false , popupmultitel :false, 
                    ecran:window.location.hostname==='localhost'?'dashboard':'dashboard',
                    disablebuttons : false,notifnew :{}  , displaycalleft:false,displaymodal : null ,
                    displaymodalcalendar : null ,
                    ecranclientselectleft :'leftselect1'  }  , 
    reducers :{ modifyEcran: (state, action)=>{state.ecran= action.payload},
                modifyDisplaymodal: (state, action)=>{state.displaymodal = action.payload}, 
                modifyDisplaymodalCalendar: (state, action)=>{state.displaymodalcalendar = action.payload}, 
                modifyDisplaycalleft: (state, action)=>{state.displaycalleft = action.payload}, 
                modifyPopupmultitel: (state, action)=>{state.popupmultitel= action.payload},
                modifyDisablebuttons: (state, action)=>{state.disablebuttons= action.payload},
                defineNotifnew : (state, action)=>{state.notifnew = action.payload},
                defineEcranclientselectleft : (state, action)=>{state.ecranclientselectleft = action.payload},
 
              }
  });


  const telSlice = createSlice({
    name : "tel" ,
    initialState :{ messagetel: '', etat:'normal' , ringfirst: false}, 
    reducers :{modifyMessagetel : (state, action)=>{state.messagetel = action.payload},
              modifyEtattel: (state, action)=>{state.etat = action.payload}  ,
              modifyRingfirst: (state, action)=>{state.ringfirst = action.payload}  ,
            } ,
              
  });


  const datagestionSlice = createSlice({
    name : "datagestion" ,
    initialState : {leads:[], datasleads:{} ,clients:[] , allstats :{}  ,  infoscourtier :{}  , dataformcourtier:{} },
    reducers :{  getAllLeads : (state, action)=>{ state.leads=action.payload },
                  getInfoscourtier : (state, action)=>{ state.infoscourtier=action.payload },
                  getDatasLeads : (state, action)=>{ state.datasleads=action.payload },
                  getAllClients : (state, action)=>{ state.clients=action.payload },
                  getAllStats: (state, action)=>{  return  {...state,allstats :{...action.payload}}} ,
                  changeDataformcourtier: (state, action)=>{ state.dataformcourtier=action.payload },
                
                }
});

const requeteSlice = createSlice({
  name: "firstrequest",
  initialState : {calendar: true,gleap: true} ,
  reducers: {defineCalendar : (state, action)=>{ state.calendar=action.payload }, 
              defineGleap : (state, action)=>{ state.gleap=action.payload }}
});

const contratchangeSlice = createSlice({
  name:"contratchange",
  initialState : {value:{}} ,
  reducers: {defineContratchange : (state, action)=>{  state.value=action.payload } }
}); 

const equipementchangeSlice = createSlice({
  name:"equipementchange",
  initialState : {value:{}} ,
  reducers: {defineEquipementchange : (state, action)=>{  state.value=action.payload } }
})



const comgestionSlice = createSlice({
  name:"comgestion",
  initialState : {value:{}} ,
  reducers: {defineComgestion: (state, action)=>{  state.value=action.payload } }
})

const emailSlice = createSlice({
  name:"email",
  initialState : {attachments:[],objet:'',message:'',messagetexte:'',typemail:'',idmailtransfer:0 , attachlinkmailtransfer:[], emailchoice: null} , 
  reducers: {defineAttachments: (state, action)=>{  state.attachments=action.payload } ,
            defineObjet: (state, action)=>{  state.objet=action.payload } ,
            defineMessage: (state, action)=>{  state.message=action.payload } ,
            defineMessagetexte: (state, action)=>{  state.messagetexte=action.payload } ,
            defineTypeMail: (state, action)=>{  state.typemail=action.payload } ,
            defineEmailchoice: (state, action)=>{  state.emailchoice=action.payload } ,
            defineIdMailTransfer: (state, action)=>{  state.idmailtransfer=action.payload } ,
            defineAttachLinkMailTransfer: (state, action)=>{  state.attachlinkmailtransfer=action.payload } ,
          }
});

const courtierSlice = createSlice({
  name:"courtier",
  initialState : {jsongammesbulletins:[]} ,
  reducers: {defineJsongammesbulletins: (state, action)=>{  state.jsongammesbulletins=action.payload } ,
          }
});


const dateactu = new Date((new Date()).setHours(0,0,0)) ;
const datedemain =  new Date((new Date()).setHours(24,0,0)) ;

function formadate(date){
    return date.getFullYear()+'-'+(date.getMonth()+1).toString().padStart(2,'0')+'-'+(date.getDate()).toString().padStart(2,'0');
}

const initialcategories ={"choiceleadsrecus":[],"choicenontraites":[],"choicenrp":[],"choiceechec":[] ,
                          "choiceencours":[],"choicedevis":[],"choicecontratsenattente":[],"choicegagnes":[],
                          "choicefauxnumeros":[],"choicefauxnumerosdoublons":[]}
const initialfilters = {'origines':'allorigines','campagnes':'allcamps','commerciaux':[]}
const gestionSlice = createSlice({
  name : "gestion" ,
  initialState : {leads:[],  affLeads:[],  affFxNum:[] , categories:initialcategories, filters:initialfilters  ,
                  fxnumeros:[],choiceliste:"choiceleadsrecus" ,typetablo:"gestion" , date1 :formadate(dateactu), date2 :formadate(datedemain)},
  reducers :{defineleads: (state, action)=>{ return  {...state,leads :action.payload} },
            defineaffLeads : (state, action)=>{return  {...state,affLeads: action.payload} }, 
            defineaffFxNum : (state, action)=>{return  {...state,affFxNum: action.payload} }, 
            defineCategories : (state, action)=>{return  {...state,categories: action.payload} }, 
            defineFilters : (state, action)=>{return  {...state,filters: action.payload} }, 
            definefxnumeros: (state, action)=>{ return  {...state,fxnumeros :action.payload} },
            definechoiceliste : (state, action)=>{return  {...state,choiceliste: action.payload} }, 
            definetypetablo : (state, action)=>{return  {...state,typetablo: action.payload} }, 
            definedate1 : (state, action)=>{return  {...state,date1: action.payload} } ,
            definedate2 : (state, action)=>{return  {...state,date2: action.payload} } ,
          
          }
});


var today = new Date();
const debutmois= new Date(new Date(today.getFullYear(), today.getMonth(), 1)); 
const finmois= new Date(new Date(today.getFullYear(), today.getMonth()+1, 0)); 
const gestioncontratsSlice = createSlice({
  name : "gestioncontrats" ,
  initialState : {date1 :debutmois, date2 :finmois},
  reducers :{definecontratsdate1 : (state, action)=>{return  {...state,date1: action.payload} } ,
            definecontratsdate2 : (state, action)=>{return  {...state,date2: action.payload} } ,
          
          }
});

export const {definecontratsdate1 ,definecontratsdate2 } = gestioncontratsSlice.actions;

export const {defineJsongammesbulletins} = courtierSlice.actions ;

export const {defineAttachments,defineObjet,defineMessage,defineMessagetexte,defineTypeMail,
  defineEmailchoice,defineIdMailTransfer, defineAttachLinkMailTransfer} = emailSlice.actions ;

export const {defineCalendar, defineGleap   } = requeteSlice.actions ;

export const {getAllLeads,getDatasLeads,getAllClients,getAllStats,  getInfoscourtier , changeDataformcourtier
             } = datagestionSlice.actions ;

export const { defineListedocs, deleteChampsLeadactu,modifyChampsLeadactu,   initialiseLeadappelant, 
                initialiseLeadactu,deleteChampsLeadmemo,modifyChampsLeadmemo,initialiseLeadmemo, 
                modifyQualiflead , initialiseLeadmemoConjoint ,initialiseLeadMemoEnfants }= leadSlice.actions;

export const {setInitiaload,allLeads,defineCampagnes, addlead,deletelead,  setFileattentes , 
              setLeadsfiltres, setFiltrescom ,setChoiceliste ,setFiltresmanager}= leadsSlice.actions ;

export const {setCorell,allFormules,defineFormuleShow,defineLoadingformules,
              defineListeCompagnies,defineListeCompagniesAffichees,
              defineDevisFormules,
              defineFavorisShow , defineAllFormulesShow, defineIdsNeeds , defineCompagnieWait ,
              defineListControllers } = formulesSlice.actions;

 export const {allcalendarevents, seteventtochange } = calendarSlice.actions;

 export const {modifyEcran ,
                modifyPopupmultitel, 
               modifyDisablebuttons , 
               defineNotifnew ,  
                modifyDisplaycalleft , 
                 modifyDisplaymodal ,
                 modifyDisplaymodalCalendar,
                 defineEcranclientselectleft,
                 } = displaySlice.actions;

 export const { modifyMessagetel  , modifyEtattel ,modifyRingfirst } = telSlice.actions;

 export const {defineContratchange} = contratchangeSlice.actions;
 export const {defineEquipementchange} = equipementchangeSlice.actions;
 
 export const {defineComgestion} = comgestionSlice.actions;

 export const {defineleads, defineaffLeads , definefxnumeros , definechoiceliste,
  definetypetablo,definedate1 ,definedate2 , defineCategories , defineFilters , defineaffFxNum} = gestionSlice.actions;

  export const resetAllStore = createAction('store/resetAll');

const rootReducer = (state, action) => {
  // Si c'est un reset, on remet state à undefined
  if (action.type === 'store/resetAll') {
    state = undefined;
  }
  
  // Retournez la structure normale de vos reducers
  return {
    gestion: gestionSlice.reducer(state?.gestion, action),
    gestioncontrats: gestioncontratsSlice.reducer(state?.gestioncontrats, action),
    email: emailSlice.reducer(state?.email, action),
    lead: leadSlice.reducer(state?.lead, action),
    leads: leadsSlice.reducer(state?.leads, action),
    formules: formulesSlice.reducer(state?.formules, action),
    display: displaySlice.reducer(state?.display, action),
    tel: telSlice.reducer(state?.tel, action),
    datagestion: datagestionSlice.reducer(state?.datagestion, action),
    calendar: calendarSlice.reducer(state?.calendar, action),
    firstrequest: requeteSlice.reducer(state?.firstrequest, action),
    contratchange: contratchangeSlice.reducer(state?.contratchange, action),
    equipementchange: equipementchangeSlice.reducer(state?.equipementchange, action),
    comgestion: comgestionSlice.reducer(state?.comgestion, action),
    courtier: courtierSlice.reducer(state?.courtier, action),
  };
};

export const store = configureStore({
    reducer: rootReducer, // Utilisez le rootReducer au lieu de l'objet
    middleware: (getDefaultMiddleware) => getDefaultMiddleware({serializableCheck: false}),
});


/*
export const storeMemo= configureStore({
    reducer :{   gestion: gestionSlice.reducer,
                gestioncontrats: gestioncontratsSlice.reducer,
                email: emailSlice.reducer,
                lead : leadSlice.reducer ,
                leads : leadsSlice.reducer  , 
                formules : formulesSlice.reducer , 
                display : displaySlice.reducer,
                tel : telSlice.reducer,
                datagestion:datagestionSlice.reducer ,
                calendar:calendarSlice.reducer  ,  
                firstrequest : requeteSlice.reducer,
                contratchange: contratchangeSlice.reducer,
                equipementchange: equipementchangeSlice.reducer,
                comgestion: comgestionSlice.reducer,
                courtier: courtierSlice.reducer,
} ,
    middleware:  (getDefaultMiddleware) =>  getDefaultMiddleware({serializableCheck: false }), 
})

*/